import { getStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import { Navigate, Outlet } from 'react-router-dom';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ROUTES } from '~/utils/routes';

export const StressAssessmentRoleRoute: React.FC = () => {
  // 実施者ビルドでは role-select 画面を経由しない運用のため役割Cookieが存在せず、
  // 判定するとストレスチェック配下すべてが role-select へリダイレクトされてしまう。
  // そのため判定をスキップしてそのまま Outlet を描画する。
  // 暫定対応: #3499 (MMT-233) でこのガード自体が削除される予定。
  if (IS_STRESS_CHECK_IMPLEMENTER_BUILD) {
    return <Outlet />;
  }

  const stressAssessmentRole = getStressAssessmentRole();
  if (!stressAssessmentRole) {
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.ROLE_SELECT} />;
  }

  return <Outlet />;
};
